export enum RouteAction {
    Editar = 'editar',
    Visualizar = 'visualizar',
    Inserir = 'inserir'
}

export enum LoginAction {
    TrocarSenha = 'trocarSenha',
    EsqueciMinhaSenha = "esqueciMinhaSenha"
}